import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

/* ... */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("h1", null, "Page not found", -1)
  ]))]))
}
}

})